import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { IBaseResponse } from "../../../model/response/IBaseResponse";
import { dotXetHocVuPhamViApi } from "../../../api/xet-hoc-vu/dotXetHocVuPhamViApi";
import { eDotXetHocVuPhamViActionIds, IDotXetHocVuPhamViActionTypes } from "../../action-types/xet-hoc-vu/IDotXetHocVuPhamViActions";
import { rootActions } from "../../actions/rootActions";
import { toLowerCaseDeep } from "../../../utils/toLowerCaseDeep";
import { IDotXetHocVuPhamVi } from "../../../model/response/xet-hoc-vu/IDotXetHocVuPhamVi";
const mainAction = rootActions.xetHocVu.dotXetHocVuPhamVi;

export function* dotXetHocVuPhamViSaga(): any {
    yield takeLatest(eDotXetHocVuPhamViActionIds.LOAD_BY_DOT_XET_START, loadByDotXetHocVuWoker);
    yield takeEvery(eDotXetHocVuPhamViActionIds.SAVE_START, saveWorker);
    yield takeEvery(eDotXetHocVuPhamViActionIds.DELETE_START, deleteWorker);
}

function* loadByDotXetHocVuWoker(action: IDotXetHocVuPhamViActionTypes ): any {
    const id_dot_xet = action.payload as number;
    const res: IBaseResponse = yield call(dotXetHocVuPhamViApi.SelectByDotXetHocVuId, id_dot_xet);
    if (res.is_success) {
        yield put(mainAction.LOAD_BY_DOT_XET_SUCCESS(toLowerCaseDeep(res.data)));
    } else {
        yield put(mainAction.LOAD_BY_DOT_XET_ERROR(res.message ?? "Có lỗi khi tải đợt xét học vụ"));
    }
}

function* saveWorker(action: IDotXetHocVuPhamViActionTypes): any {
    const payload = action.payload as IDotXetHocVuPhamVi;
    const res: IBaseResponse = yield call(dotXetHocVuPhamViApi.Insert, payload);
    if (res.is_success) {
        yield put(mainAction.SAVE_SUCCESS(res.data));
    } else {
        yield put(mainAction.SAVE_ERROR(res.message ?? "Có lỗi khi lưu phạm vi đợt xét học vụ"));
    }
}

function* deleteWorker(action: IDotXetHocVuPhamViActionTypes): any {
    const id = action.payload as number;
    const res: IBaseResponse = yield call(dotXetHocVuPhamViApi.Delete, id);
    if (res.is_success) {
        yield put(mainAction.DELETE_SUCCESS(res.data));
    } else {
        yield put(mainAction.DELETE_ERROR(res.message ?? "Có lỗi khi xóa phạm vi đợt xét học vụ"));
    }
}